import Model from "./Model";

export default class BoardSectionModel extends Model {
  id: number;
  title: string;

  static __typename: string = "BoardSection";

  constructor(boardSection: any, getters: any) {
    super(getters);
    this.title = boardSection.title;
    this.id = boardSection.id;
  }
}